import i18n from "app/i18n";
import { BoxDanger, MnemoLoading, Title } from "components/misc";
import { LESSON_TYPE, ROUTES } from "const";
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Container } from "design-react-kit";
import { MTable } from "components/table";
import { adminService, dateHelper, networkErrorHelper } from "libs";
import dayjs from "dayjs";
import { getCurrentRegion } from "store/actions";

class DashboardStewardAttendees extends Component {
  state = {
    loading: false,
    idLesson: 0,
    lessonType: "",
    rndKey: 0,
    payload: [],
    payloadToRender: [],
    currentRegion: "",
  };

  componentDidMount() {
    const currentRegion = getCurrentRegion();
    if (currentRegion) {
      this.setState({ currentRegion });
    } else {
      // redirect to dashboard steward
      this.props.history.push(ROUTES.STEWARD_DASHBOARD);
    }

    const { idLesson, lessonType } = this.props.match.params;
    this.setState({ idLesson, lessonType });

    // Check if idLesson and lessonType are valid
    if (idLesson && lessonType) {
      this.loadRemoteAttendees(idLesson, lessonType, currentRegion);
    } else {
      console.error("Invalid parameters: idLesson or lessonType is missing.");
    }
  }

  //--- ---
  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "Column 0",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "surname",
      },
      {
        id: "name",
        Header: "Nome",
        accessor: "name",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "registrationCode",
      },
      {
        id: "competitionClass",
        Header: "Classe di concorso",
        accessor: (row) => {
          return row?.competitionClass?.length > 10
            ? row.competitionClass.replaceAll(",", ", ")
            : row.competitionClass;
        },
      },
      {
        id: "region",
        Header: "Regione",
        accessor: "region",
      },
      {
        id: "email",
        Header: "Email",
        accessor: "email",
      },
      {
        id: "mobile",
        Header: "Telefono",
        accessor: "mobile",
      },
      {
        id: "presence",
        Header: "Presente",
        accessor: "presence",
      },
      {
        id: "scansioni",
        Header: "Scansioni",
        accessor: (row) => {
          return row?.scanList?.length || ''
        },
      },
    ],
    actions: [
      {
        id: "detail",
        accessor: "id",
        label: "Dettagli",
        icon: "it-file",
        className: "MTable-actions",
        onClick: (e, value) => {
          this.showDetailScan(e, value);
        },
      },
    ],
  };

  loadRemoteAttendees(idLesson, lessonType, currentRegion) {
    this.setState({ loading: true });

    const payload = {
      idLesson,
      lessonType,
      currentRegion,
    };

    let api = null;
    if (lessonType === LESSON_TYPE.LESSON_ONSITE) {
      api = adminService.loadLessonOnSiteAttendees(payload);
    }
    if (lessonType === LESSON_TYPE.LESSON_TRAINING) {
      api = adminService.loadTrainingAttendees(payload);
    }

    if (api === null) {
      return true;
    }

    api
      .then(({ data }) => {
        /*
        let objRet = data.payload.allowUserLesson || [];

        //--- start: prepare reactTable ---
        const items = [];
        Object.entries(objRet).forEach(([key, val]) => {
          items.push(val);
        });
        //--- end: prepare reactTable ---
*/
        const items = data.payload.allowUserLesson || [];

        const payloadToRender = items.filter(
          (item) => item.region.toUpperCase() === currentRegion.toUpperCase()
        );

        this.setState({
          loading: false,
          payload: items,
          payloadToRender,
          rndKey: Math.floor(Math.random() * 1000 + 1),
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
        if (!networkErrorHelper.is404(error)) {
          networkErrorHelper.notify(error);
        } else {
          this.setState({
            payload: [],
            payloadToRender: [],
            rndKey: Math.floor(Math.random() * 1000 + 1),
          });
        }
      });
  }

  onExport = () => {
    //--- prepare header ---
    let str = "";
    str +=
      "Cognome;Nome;Codice Registraione;Classe di Concorso;Regione;Email;Telefono;Presenza;Scansioni;Entrata;Uscita\r\n";

    for (let i = 0; i < this.state.payloadToRender.length; i++) {
      const rows = this.state.payloadToRender[i];
      //--- make rows ---
      const columnOrder = [
        "surname",
        "name",
        "registrationCode",
        "competitionClass",
        "region",
        "email",
        "mobile",
        "presence"
      ];

      let line = "";

      for (const col of columnOrder) {
        if (line !== "") line += ";";
        line += rows[col] !== undefined ? rows[col] : "";
      }

      //--- add login / logout datetime ---
      if (rows.scanList && rows.scanList.length > 0) {
        const firstScanLogin = rows.scanList.filter((item) => item.action === 'login');
        const lastScanLogout = rows.scanList.filter((item) => item.action === 'logout');

        let tmpLogin = "";
        let tmpLogout = "";
        
        if (firstScanLogin.length > 0) {
          tmpLogin = dateHelper.toITDateTime(firstScanLogin[0].actionDate);
        }

        if (lastScanLogout.length > 0) {
          tmpLogout = dateHelper.toITDateTime(lastScanLogout[lastScanLogout.length - 1].actionDate);
        }

        line += `;${rows.scanList.length};${tmpLogin};${tmpLogout}`;
      }

      str += line + "\r\n";
    }

    //--- start download ---
    let downloadLink = document.createElement("a");
    downloadLink.href =
      "data:text/csv;charset=utf-8," + encodeURIComponent(str);
    downloadLink.download =
      "presenze_" +
      this.state.currentRegion +
      "_" +
      i18n.t(this.state.lessonType).toLocaleLowerCase().replace(/\s+/g, "") +
      "_" +
      dayjs(this.state.payloadToRender[0].date).format("DDMMYYYY") +
      "_" +
      this.state.payloadToRender[0].hourStart.slice(0, -3) +
      "_esportato_il_" +
      dayjs().format("DD_MM_YYYY_H_m_s") +
      ".csv";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  showDetailScan = (e, id) => {
    const existingTr = document.getElementById(`tr_${id}`);
    if (existingTr) {
      existingTr.remove(); // remove the existing detail row if it exists
      return;
    }

    const tr = e.currentTarget.closest("tr");
    if (!tr) return;

    // prepare data to show
    const list = this.state.payloadToRender.filter((item) => item.id === id);

    // make new <tr> element
    const newTr = document.createElement("tr");
    newTr.id = `tr_${id}`;

    const td = document.createElement("td");
    td.colSpan = 9;

    if (list.length === 0) {
      td.innerHTML = `<div class="bold text-red">Non sono presenti informazioni.</div>`;
    } else {
      // make list of scans
      let scans = "";
      (list[0].scanList || []).forEach((item) => {
        scans += `<ul class="m-1 p-3 list-unstyled rounded text-white ${item.action === "login" ? "bg-success" : "bg-danger"}">
            <li class="small m-0 p-0 text-upper">${item.action}</li>
            <li class="small m-0 p-0">${dateHelper.toITDateTime(item.actionDate)}</li>
            <li class="small m-0 p-0"><span class="bold">scanner: </span>${item.idOperator}</li>
          </ul>`;
      });

      td.innerHTML = `<div class="d-flex py-2 px-0 flex-nowrap align-content-stretch gap-2">${scans}</div>`;
    }

    // add
    newTr.appendChild(td);

    // add new <tr> after the current <tr>
    tr.insertAdjacentElement("afterend", newTr);
  };

  //--- ---

  render() {
    const { loading, lessonType, payloadToRender, currentRegion } = this.state;

    let title = i18n.t(lessonType);
    if (payloadToRender && payloadToRender.length > 0) {
      title +=
        " del " +
        dateHelper.toITDate(payloadToRender[0]?.date) +
        " ore " +
        payloadToRender[0]?.hourStart?.slice(0, -3);
    }

    return (
      <>
        <div className="container mt-3 mb-4">
          <section className="my-4">
            <Container>
              <Title subtitle={`REGIONE ${currentRegion.toUpperCase()}`}>
                {title}
              </Title>
            </Container>
          </section>

          <div className="form-row mb-4">
            <div className="col-md-4">
              <button
                className="btn btn-primary bg-dark mx-1"
                onClick={(e) => {
                  this.onExport(e);
                }}
              >
                Esporta
              </button>
            </div>
          </div>

          <hr />

          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <>
                <Container>
                  <MTable
                    key={this.state.rndKey}
                    tableData={this.state.payloadToRender}
                    tableConfig={this.tableConfig}
                  />
                </Container>
                {this.state.payloadToRender.length === 0 && (
                  <BoxDanger key="nrp-1" className="my-3">
                    <div className="small text-info">
                      Nessun partecipante alla lezione
                    </div>
                  </BoxDanger>
                )}
              </>
            )}
          </section>
        </div>
      </>
    );
  }
}

export default withRouter(DashboardStewardAttendees);
